import React from 'react';
import PropTypes from 'prop-types';

import Container from './Container';

const Table = ({ items, parentIndex, parentId, handleSortStart, handleSortEnd }) => (
  <Container
    helperClass="on-drag-ticket"
    items={items}
    parentIndex={parentIndex}
    parentId={parentId}
    onSortStart={handleSortStart}
    onSortEnd={handleSortEnd}
    useDragHandle
  />
);

Table.propTypes = {
  items: PropTypes.array,
  parentIndex: PropTypes.number,
  parentId: PropTypes.number,
  handleSortStart: PropTypes.func,
  handleSortEnd: PropTypes.func,
};

export default Table;
